"use client";
import React from "react";
import Image from "next/image";
import { AspectRatio, Center, HStack } from "@chakra-ui/react";
import { Heading } from "@/elements";
import PrivateCloudWhite from "public/cloud-services/private-cloud-white.svg";
import PrivateCloud from "public/cloud-services/private-cloud.svg";
import PocCloudCards from "./pocCloud";
import PrivateCloudCards from "./privateCloud";
import PublicCloudCards from "./publicCloud";
import { SERVICES_TABS } from "./constants";

export const tablist = [
  {
    component: <PublicCloudCards />,
    label: ({ isSelected }) => (
      <Center>
        <HStack gap={2}>
          <AspectRatio ratio={1} w={"24px"} position={"relative"}>
            <Image
              alt="private cloud"
              src={isSelected ? PrivateCloudWhite : PrivateCloud}
              fill
              style={{ objectFit: "contain", objectPosition: "center" }}
            />
          </AspectRatio>
          <Heading as="h3" fontWeight={600} variant={"subTitle3"}>
            {SERVICES_TABS.PUBLIC_CLOUD}
          </Heading>
        </HStack>
      </Center>
    ),
  },
  {
    component: <PrivateCloudCards />,
    label: ({ isSelected }) => (
      <Center>
        <HStack gap={2}>
          <AspectRatio ratio={1} w={"24px"} position={"relative"}>
            <Image
              alt="private cloud"
              src={isSelected ? PrivateCloudWhite : PrivateCloud}
              fill
              style={{ objectFit: "contain", objectPosition: "center" }}
            />
          </AspectRatio>
          <Heading as="h3" fontWeight={600} variant={"subTitle3"}>
            {SERVICES_TABS.PRIVATE_CLOUD}
          </Heading>
        </HStack>
      </Center>
    ),
  },
  {
    component: <PocCloudCards />,
    label: ({ isSelected }) => (
      <Center>
        <HStack gap={2}>
          <AspectRatio ratio={1} position={"relative"} w={"24px"}>
            <Image
              alt="poc cloud"
              src={isSelected ? PrivateCloudWhite : PrivateCloud}
              fill
              style={{ objectFit: "contain", objectPosition: "center" }}
            />
          </AspectRatio>
          <Heading as="h3" fontWeight={600} variant={"subTitle3"}>
            {SERVICES_TABS.POC_CLOUD}
          </Heading>
        </HStack>
      </Center>
    ),
  },
];
